export class IdentityResolver {
}
//# sourceMappingURL=identity.interface.js.map